import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { changeParamsDiscount } from '../../../../cartAndOrders/store/slice'
import { getDiscount } from '../../../../cartAndOrders/store/thunk'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Popup } from '../../../../common/popup'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { TYPES_DISCOUNT } from '../../../../utils/common'
import classes from '../../../index.module.scss'
import {
  changeKeyCheckValidVolume,
  selectBuyPackage,
  selectKeyCheckValidVolume,
  selectListValidVolume,
  selectUniquePackageTypes,
  setBuyOnePackage,
  setListPackage,
} from '../../store/slice'
import { BuyMorePackage } from './BuyMorePackages'
import { BuyOnePackage } from './BuyOnePackage'
import { GroupButton } from './common/GroupButton'

const ONE_PACKAGE = 1

export const PopupBuyPackage = ({
  isShow,
  setIsShow,
  defaultReportId,
  setIsOpenBuyNow,
  userProfile,
  loadingUserProfile,
}) => {
  const dispatch = useDispatch()

  const { height } = useViewport()

  const [disableVolume, setDisableVolume] = useState(false)

  const buyPackage = useSelector(selectBuyPackage)
  const packageTypes = useSelector(selectUniquePackageTypes)
  const keyCheckValidVolume = useSelector(selectKeyCheckValidVolume)
  const listValidVolume = useSelector(selectListValidVolume)
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const isDisableCheckout =
    AUTHORIZATION_API.allowCheckout[userType.userTypeId] ===
    AUTHORIZATION_TYPE.DISABLE

  const isBuyOnePackage = buyPackage?.isBuyOne
  const listPackage = buyPackage?.listPackage

  const handleClose = () => {
    setIsShow(false)
  }

  const buyNow = () => {
    dispatch(changeKeyCheckValidVolume())
    if (listPackage?.some((item) => !item.volume)) return

    if (isDisableCheckout) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [<Translate value="cartAndOrders.message.m20" />],
      })
      setIsShow(false)
      return
    }

    setIsOpenBuyNow(true)
    setIsShow(false)
  }

  const isDisableGroupBtn = listPackage?.every((item) => item.isContactUs)

  useEffect(() => {
    if (listPackage.length === ONE_PACKAGE) {
      dispatch(setBuyOnePackage(true))
    }
  }, [listPackage])

  useEffect(() => {
    dispatch(
      setListPackage([
        {
          rowId: 0,
          packageTypeId: packageTypes[0]?.id,
          packageTypeName: packageTypes[0]?.name,
          pricingPackageId: packageTypes[0]?.pricingPackageId,
          discountId: packageTypes[0]?.discountId,
          discountPercentage: packageTypes[0]?.discountPercentage,
        },
      ]),
    )
    dispatch(
      changeParamsDiscount([TYPES_DISCOUNT.SNPOrder, TYPES_DISCOUNT.Package]),
    )
    dispatch(getDiscount())
  }, [])

  useDidUpdateEffect(() => {
    setDisableVolume(!Object.values(listValidVolume).every((item) => !!item))
  }, [keyCheckValidVolume, listValidVolume])

  return (
    <>
      {isShow && (
        <Popup
          zIndexPopup={99}
          appendStyleContent={{
            width: 520,
            padding: '20px',
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
          }}
        >
          <div
            style={{
              maxHeight: 0.9 * height,
            }}
          >
            <div className={[classes.popupBuyPackage].join(' ')}>
              <Element
                className={[
                  'dFlex justifyContentBetween alignItemsCenter',
                  classes.header,
                ].join(' ')}
                style={{
                  borderBottom: '1px solid #e5e5e8',
                }}
              >
                <Element
                  elementName="span"
                  style={{
                    fontSize: 20,
                    fontWeight: 500,
                    lineHeight: '24px',
                    color: '#0553A5',
                    width: `calc(100% - 30px)`,
                  }}
                >
                  <Translate value="userManagement.buyPackage.BUY_PACKAGE" />
                </Element>
                <Element onClick={handleClose}>
                  <Icon
                    className="icon-delete"
                    style={{ fontSize: 12, color: '#9C9C9C' }}
                  />
                </Element>
              </Element>
              {isBuyOnePackage ? (
                <BuyOnePackage defaultReportId={defaultReportId} />
              ) : (
                <BuyMorePackage defaultReportId={defaultReportId} />
              )}
            </div>
            <GroupButton
              isBuyPackage
              isDisableGroupBtn={isDisableGroupBtn || disableVolume}
              buyNow={buyNow}
              userProfile={userProfile}
              loadingUserProfile={loadingUserProfile}
            />
          </div>
        </Popup>
      )}
    </>
  )
}
